<template>
  <div class="modal-project-complete">
    <img class="close-img" src="/../img/ic-m-close.svg" @click="onClick" />
    <div class="slot1">
      <span>{{ $t("project.add.success") }}</span>
    </div>
    <div class="slot2">
      <span>{{ $t("project.add.web_code") }}</span>
      <!-- <span>웹 페이지 HTML &lt;head&gt; 태그에 아래의 코드를 붙여넣어주세요.</span> -->
    </div>
    <div class="slot3">
      <div class="source_slot">
        <button class="copy" @click="copy"></button>
        <pre id="code">
&lt;script src=&quot;{{ $store.state.setting.agent_setting.web_agent.url
          }}{{
            $store.state.setting.agent_setting.web_agent.version
          }}.js&quot;&gt;&lt;/script&gt;
&lt;script&gt;
    ((w, c, _wv, _w, _wk, _mh, _b) => {
      w[c] = w[c] || {};
      function imqaConf(key, value){w[c][key]=value};

      imqaConf(&quot;imqaAgentUse&quot;, true);
      imqaConf(&quot;projectKey&quot;, &quot;{{
            $store.state.modalProps.pKey
          }}&quot;);

      if ((w[_wk] !== undefined && w[_wk][_mh] !== undefined) || w[_b] !== undefined) w[_wv](w);
      else w[_w](w);

    })(window, &quot;imqaClientConfig&quot;, &quot;IMQAWebviewMain&quot;, &quot;IMQAWebMain&quot;, &quot;webkit&quot;, &quot;messageHandlers&quot;, &quot;ImqaBridge&quot;)
&lt;/script&gt;
				</pre
        >
      </div>
    </div>
    <div class="slot4">
      <button class="submit-btn" type="button" @click="onClick">완료</button>
    </div>
    <div class="footer">
      <a href="http://imqa.io/documents" target="_blank">
        <img src="/../img/icon-guide-pg.svg" />
        <span>{{ $t("project.add.guide") }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import CopyButton from "@/views/components/copy-button";

export default {
  name: "modal-project-create-complete",
  components: {
    CopyButton,
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {
    onClick() {
      this.$emit("closeEvent", true);
    },
    copy(event) {
      event.stopPropagation();
      var codeElement = document.querySelector("#code");
      var codeText = codeElement.innerText;
      var textarea = document.createElement("textarea");
      textarea.value = codeText;

      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, 9999); // 추가

      document.execCommand("copy");
      document.body.removeChild(textarea);
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-project-complete {
  margin: auto;
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.54);
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  z-index: 4;
  box-sizing: border-box;
  width: 475px;
  height: 517px;
  .slot1 {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 25px;
    & > span {
      font-size: 18px;
      color: #000000;
    }
  }
  .slot2 {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 29px;
    & > span {
      font-size: 13px;
      color: #848484;
    }
  }
  .slot3 {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 25px;
    .source_slot {
      background-color: #f6f7fa;
      width: 375px;
      height: 227px;
      padding: 10px;
      position: relative;
      & > .copy {
        position: absolute;
        left: 372px;
        top: 4px;
        cursor: pointer;
        outline: none;
        border: none;
        width: 20px;
        height: 20px;
        background: url(@/assets/img/icon-copy-default.svg) no-repeat center;
        background-size: 20px;
        &:hover {
          background: url(@/assets/img/icon-copy-hover.svg);
          background-size: 20px;
        }
      }
      & > pre {
        width: 375px;
        height: 227px;
        line-height: 22px;
        overflow: scroll;
      }
    }
  }
  .slot4 {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 23px;
  }
}
@mixin btn-text {
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  outline: none;
  border: none;
}
.submit-btn {
  @include btn-text;
  float: left;
  width: 192px;
  height: 43px;
  border-radius: 20px;
  box-shadow: 0 2px 4px 0 #c6d5e9;
  background-color: #4639de;
  border: none;
}
.close-img {
  position: absolute;
  top: 0px;
  cursor: pointer;
  left: 485px;
}
.footer {
  width: 100%;
  height: 59px;
  box-sizing: border-box;
  background-color: #f6f6f6;
  border-radius: 8px;
  margin-top: 20px;
  a {
    box-sizing: border-box;
    text-decoration: none;
    color: #000000;
    padding: 18px 40px;
    display: inline-block;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    background: url(@/assets/img/btn-guide-go.svg) no-repeat 94% 50%;
    img {
      position: relative;
      top: 3px;
    }
    span {
      font-size: 14px;
      margin-left: 7px;
    }
  }
}
.color_blue {
  color: #4639de;
}
</style>
